import { Row } from "antd";
import React, { memo, useMemo } from "react";
import Warning from "src/components/GlobalIconPart/Warning";
import { Composition } from "src/entity/flare/flare.constants";
import { ResponseHeatingValue } from "src/entity/flare/heating-value.entity";

interface NumberRowProps {
  no: number;
  record: ResponseHeatingValue;
}

const NumberRow: React.FC<NumberRowProps> = memo(({ no, record }) => {
  const hasFullComposition = useMemo(() => {
    if (record.composition === Composition.SPECIFIC_HEATING_VALUE) return true;
    return record.specificComposition.every((item) => item.compound.isActive === true);
  }, [record]);

  return (
    <Row justify={"start"}>
      {!hasFullComposition ? <Warning title={"Some compound was deleted."} /> : <></>}
      <div>{no}</div>
    </Row>
  );
});

export default NumberRow;
